import { IProgramId } from '@ucheba/store/institutions/programs/programId/types'

export const getProgramDescription = (program?: IProgramId | null): string => {
  if (program?.shortDescription) {
    return program.shortDescription
  }

  if (program?.description) {
    return program.description
  }

  if (program?.name) {
    return `Программа обучения «${program.name}»${`, ${program?.programType?.name}` || ''} ${`, ${program.speciality?.codeOkso}` || ''} в учебном заведении ${program.institution?.name} — условия поступления, варианты и стоимость обучения, отзывы о программе.`
  }

  return ''
}
